export const DEFAULTS = {
  position: "top-right",
  dismissible: true,
  dismissAfter: 5000,
  showDismissButton: true,
};
